/*
 * @Author: hai.zhang
 * @LastEditors: hai.zhang
 */
import moment from 'moment'
import Api from './api'
import response from '../../../utils/response/index.js'

moment.locale('zh-cn')
export default {
  data () {
    return {
      STATUS: {
        INIT: 'init' // 初始化
      },
      CLIENT_TYPE_CONST: {
        mall: {
          code: 'mall',
          name: '需求用户',
          url: 'demandUsersUrl'
        },
        supplier: {
          code: 'supplier',
          name: '供应商',
          url: 'supplierUrl'
        },
        purchaser: {
          code: 'purchaser',
          name: '采购员',
          url: 'buyerUrl'
        }
      }
    }
  },
  methods: {
    isImg (fileSuffix) {
      let imgSuffix = ['jpeg', 'gif', 'jpg', 'png', 'bmp', 'svg']
      // console.log(fileSuffix)
      // 没有后缀
      if (fileSuffix === '') {
        return false
      }
      return imgSuffix.some(item => item === fileSuffix)
    },
    isSupplier (clientType) {
      return clientType === this.CLIENT_TYPE_CONST['supplier'].code
    },
    getCompanyName (msgItem, connector) {
      // 只有供应商展示公司名称
      if (this.isSupplier(msgItem.toClientType)) {
        return msgItem.toSupplierName + (connector || '')
      } else {
        return ''
      }
    },
    getIdentity (msgItem) {
      let item = null
      for (let key in this.CLIENT_TYPE_CONST) {
        if (this.CLIENT_TYPE_CONST[key].code === msgItem.toClientType) {
          item = this.CLIENT_TYPE_CONST[key]
        }
      }
      return item ? item.name : ''
    },
    async updateMsgStatus (id) {
      const api = Api.updateMsgStatus
      const res = await response(this.$http(api.type, api.url, {
        clientType: this.activeMsgItem.clientType,
        bizDataCode: this.activeMsgItem.acceptorId,
        toId: this.activeMsgItem.toId,
        applyFormCode: this.activeMsgItem.applyFormCode,
        msgId: id || null
      }))
      if (res.isOk) {
        // console.log('更新')
      }
    },
    getSuffix (name = '') {
      let fileSuffix = ''
      if (name.indexOf('.') !== -1) {
        fileSuffix = name.split('.').pop()
      }
      return fileSuffix
    },
    getFileIcon (fileSuffix) {
      const icons = {
        other: this.syImgUrl + '162510955563367173.svg',
        pdf: this.syImgUrl + '16250569944899732.svg',
        doc: this.syImgUrl + '162505699442013574.svg',
        docx: this.syImgUrl + '162505699442013574.svg',
        xls: this.syImgUrl + '162505699421452651.svg',
        xlsx: this.syImgUrl + '162505699421452651.svg',
        ppt: this.syImgUrl + '162505699428230929.svg',
        pptx: this.syImgUrl + '162505699428230929.svg',
        txt: this.syImgUrl + '162505699435144839.svg',
        rar: this.syImgUrl + '162505699409888747.svg',
        zip: this.syImgUrl + '162505699409888747.svg'
      }
      return icons[fileSuffix] || icons['other']
    },
    handleTime (date, currentFormat, beforeFormat) {
      let sendTime = new Date(date).getTime()
      let presentTime = new Date(new Date(Date.now()).setHours(0, 0, 0, 0)).getTime()
      let newYearTime = new Date(`${new Date().getFullYear()}-01-01 00:00`).getTime()
      // let millisecondsPerDay = 1 * 24 * 60 * 60 * 1000
      // console.log(presentTime - sendTime)
      return presentTime < sendTime 
        ? moment(sendTime).format(currentFormat || 'HH:mm') 
        : (newYearTime < sendTime 
          ? moment(sendTime).format(beforeFormat || 'MM-DD HH:mm')
          : moment(sendTime).format(beforeFormat || 'YYYY-MM-DD HH:mm')
        )
    },
    // 处理数据
    handleData (msgList) {
      // console.log(msgList)
      msgList.forEach(item => {
        // 如果是文件类型
        if (parseInt(item.msgType) === 2) {
          item.msgBody = (item.msgBody && JSON.parse(item.msgBody)) || {}
          let fileSuffix = this.getSuffix(item.msgBody.originalName)
          let isImg = this.isImg(fileSuffix)
          // 消息体转json
          // 判断是否是图片
          // console.log(item.sendTime)
          item.msgBody.isImg = this.isImg(fileSuffix)
          if (!isImg) {
            item.msgBody.fileIcon = this.getFileIcon(fileSuffix)
            item.msgBody.fileSuffix = fileSuffix
          }
        }
        // let sendTime = new Date(item.sendTime).getTime()
        // let presentTime = new Date(new Date(Date.now()).setHours(0, 0, 0, 0)).getTime()
        // let millisecondsPerDay = 1 * 24 * 60 * 60 * 1000
        item.showTime = this.handleTime(item.sendTime)
      })
      return msgList
    }
  }
}